import { atom } from "recoil";

export const reviewCCFiltersAtom = atom({
  key: "review-cc-filters",
  default: { view: "cc", group: "none" },
});
